export enum InputMode {
    Continuous,
    Discrete,
}
